import { SVGProps, FC } from 'react'

interface IProps extends SVGProps<SVGSVGElement> {}

const Verify: FC<IProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <path
        d="M12.5698 18L16.1848 21.63L23.4298 14.37"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1248 3.67498C17.1598 2.78998 18.8548 2.78998 19.9048 3.67498L22.2748 5.71498C22.7248 6.10498 23.5648 6.41998 24.1648 6.41998H26.7148C28.3048 6.41998 29.6098 7.72498 29.6098 9.31498V11.865C29.6098 12.45 29.9248 13.305 30.3148 13.755L32.3548 16.125C33.2398 17.16 33.2398 18.855 32.3548 19.905L30.3148 22.275C29.9248 22.725 29.6098 23.565 29.6098 24.165V26.715C29.6098 28.305 28.3048 29.61 26.7148 29.61H24.1648C23.5798 29.61 22.7248 29.925 22.2748 30.315L19.9048 32.355C18.8698 33.24 17.1748 33.24 16.1248 32.355L13.7548 30.315C13.3048 29.925 12.4648 29.61 11.8648 29.61H9.26982C7.67982 29.61 6.37482 28.305 6.37482 26.715V24.15C6.37482 23.565 6.05982 22.725 5.68482 22.275L3.65982 19.89C2.78982 18.855 2.78982 17.175 3.65982 16.14L5.68482 13.755C6.05982 13.305 6.37482 12.465 6.37482 11.88V9.29998C6.37482 7.70998 7.67982 6.40498 9.26982 6.40498H11.8648C12.4498 6.40498 13.3048 6.08998 13.7548 5.69998L16.1248 3.67498Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Verify
